<template>

    <div class="">

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" @reset="reset">
                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                </select-input>
                <select-input label="attachment_type" v-model="form.attachment_type">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="k" v-for="(v, k) in attachmentTypeOptions">{{ v }}</option>
                </select-input>
                <select-input label="status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <!--<file-input :floating="true" :form="uploadForm" v-model="uploadForm.upload_files" :error="uploadForm.errors.upload_files" accept="*" multiple />-->

        <div class="d-flex justify-content-between">
            <results :meta="attachments.meta" />
        </div>

        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4 mb-4">
            <div class="col" v-for="attachment in attachments.data">
                <div class="card shadow-none border">
                    <img :src="attachment.thumbnail_url" class="card-img-top" alt="" @click="selectAttachment(attachment)" style="cursor: pointer; object-fit: contain;" />
                    <div class="card-body p-3">
                        <h5 class="card-title">{{ attachment.title }}</h5>
                        <inertia-link :href="route('admin.attachments.edit', attachment)">
                            {{ __('Edit') }}
                        </inertia-link>
                    </div>
                </div>
            </div>
        </div>

        <pagination :links="attachments.meta.links" />

    </div>

</template>

<script>

    import TextInput from '@/shared/Inputs/TextInput';
    import FileInput from '@/shared/Inputs/FileInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import Results from '@/shared/Admin/Results';
    import Pagination from '@/shared/Admin/Pagination';
    import BlankLayout from '@/shared/Admin/BlankLayout';

    export default {
        layout: BlankLayout,
        props: [
            'filters',
            'suppliers',
            'attachments',
            'attachmentTypeOptions',
        ],
        components: {
            TextInput,
            FileInput,
            SelectInput,
            SearchFilter,
            Results,
            Pagination,
            BlankLayout,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    attachment_type: this.filters.attachment_type,
                    supplier_id: this.filters.supplier_id,
                },
                uploadForm: this.$inertia.form({
                    upload_files: null,
                }),
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.attachments.index', {embed: true}), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            selectAttachment(attachment) {
                console.log('@todo add to parent frame');
            },
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        }
    }
</script>